import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { List } from 'immutable'
import { pluralize } from 'humanize-plus'
import { compose, withHandlers, withProps } from 'recompose'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookModels from 'app/modules/playbook/models'
import * as OrgSelectors from 'app/modules/org/selectors'
import { weakUuid } from 'app/modules/playbook/helpers'
import { isOnFreePlan } from 'app/modules/gates/selectors'

import TargetingDisplay from './component'

const mapStateToProps = state => ({
  org: OrgSelectors.org(state),
  targetingConditionsCount: PlaybookSelectors.getNumConditions(state),
  firstCondition: PlaybookSelectors.getFirstCondition(state),
  isOnFreePlan: isOnFreePlan(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      addConditionSet: PlaybookActions.addConditionSet,
      addCondition: PlaybookActions.addCondition,
      resetDisplayConditions: PlaybookActions.resetDisplayConditions,
      setConditionValue: PlaybookActions.setConditionValue,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    alwaysSelected: props.targetingConditionsCount === 0,
    displayTargetingSelected: props.targetingConditionsCount > 0 && !props.isOnFreePlan,
    displayOnlineSelected: props.isOnFreePlan && !!props.firstCondition && !!props.firstCondition.value,
    displayOfflineSelected: props.isOnFreePlan && !!props.firstCondition && !props.firstCondition.value,
  })),
  withHandlers({
    onAlwaysClick: props => () => {
      if (
        props.targetingConditionsCount > 1 &&
        confirm(
          `Are you sure you want to set to Always? This will delete ${props.targetingConditionsCount} targeting ${pluralize(
            props.targetingConditionsCount,
            'condition'
          )}.`
        )
      ) {
        props.actions.resetDisplayConditions()
      } else if (props.targetingConditionsCount === 1) {
        // just delete if only one...
        props.actions.resetDisplayConditions()
      }
    },
    onDisplayClick: props => () => {
      const conditionSetId = weakUuid()
      if (props.targetingConditionsCount === 0 && !!props.org.properties.verificationUrl) {
        props.actions.addConditionSet({
          conditionSet: PlaybookModels.ConditionSet({
            id: conditionSetId,
          }),
        })
        const defaultUrl = props.org.properties.verificationUrl
        props.actions.addCondition({
          conditionSetId,
          condition: PlaybookModels.Condition({
            id: weakUuid(),
            value: List.of(defaultUrl),
          }),
        })
      }
      props.router.replace(`/playbooks/${props.params.playbookId}/edit/targeting/displaywhen`)
    },
    onDisplayOnlineClick: props => () => {
      if (!props.firstCondition) {
        const conditionSetId = weakUuid()
        props.actions.addConditionSet({
          conditionSet: PlaybookModels.ConditionSet({
            id: conditionSetId,
          }),
        })
        props.actions.addCondition({
          conditionSetId,
          condition: PlaybookModels.Condition({
            id: weakUuid(),
            value: true,
            field: 'online',
            operator: 'is',
          }),
        })
      } else {
        props.actions.setConditionValue({ id: props.firstCondition.id, value: true })
      }
    },
    onDisplayOfflineClick: props => () => {
      if (!props.firstCondition) {
        const conditionSetId = weakUuid()
        props.actions.addConditionSet({
          conditionSet: PlaybookModels.ConditionSet({
            id: conditionSetId,
          }),
        })
        props.actions.addCondition({
          conditionSetId,
          condition: PlaybookModels.Condition({
            id: weakUuid(),
            value: false,
            field: 'online',
            operator: 'is',
          }),
        })
      } else {
        props.actions.setConditionValue({ id: props.firstCondition.id, value: false })
      }
    }
  })
)(TargetingDisplay)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/index.js